import { ICampaign } from '../../models/campaign';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ISession } from '../../models/session';


export const resolveStateClass = (state: string | undefined): string => {
  switch (state) {
    case 'draft':
      return 'label-dark';
    case 'scheduled':
      return 'label-info';
    case 'send_pending':
    case 'queued':
    case 'Queued':
    case 'sending':
    case 'Sending':
      return 'label-success';
    case 'canceled':
    case 'Canceled':
    case 'Cancelled':
      return 'label-warning';
    case 'completed':
    case 'Completed':
      return 'label-primary';
    case 'finished':
    case 'Finished':
      return 'label-primary';
    case 'failed':
    case 'Failed':
      return 'label-danger';
    default:
      return 'label-default';
  }
}
@Injectable()
export class CampaignsService extends BasicService {
  private API = config.emailsv3.url;

  constructor(
    protected authService: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(authService, translate);
  }

  public getBySession(
    session: ISession,
    page: number = 1,
    limit: number = 10,
    sortBy: string = 'created_at',
    sortOrder: 'asc' | 'desc' = 'desc',
    notify: boolean = false
  ): Observable<{ data: ICampaign[], meta: { total: number, page: number, limit: number, totalPages: number, activeJobs?: any[] } }> {
    const params = `page=${page}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`;
    return this.http
      .get(`${this.API}/sessions/${session.id}/campaigns?${params}`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public getById(session: ISession, id: number, notify: boolean = false): Observable<ICampaign> {
    return this.http
      .get(`${this.API}/sessions/${session.id}/campaigns/${id}`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public create(session: ISession, campaign: ICampaign, dryRun: boolean = true, notify: boolean = true): Observable<ICampaign> {
    return this.http
      .post(`${this.API}/sessions/${session.id}/campaigns`, campaign, {params: { dryrun: dryRun }})
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public update(session: ISession, id: number, campaign: Partial<ICampaign>, dryRun: boolean = true, notify: boolean = true): Observable<ICampaign> {
    return this.http
      .patch(`${this.API}/sessions/${session.id}/campaigns/${id}`, campaign, {params: { dryrun: dryRun }})
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public cancel(session: ISession, id: number, notify: boolean = true): Observable<any> {
    return this.http
      .post(`${this.API}/sessions/${session.id}/campaigns/${id}/cancel`, {})
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public delete(session: ISession, id: number, notify: boolean = true): Observable<void> {
    return this.http
      .delete(`${this.API}/sessions/${session.id}/campaigns/${id}`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/campaigns.service.ts